import {
  faCloud,
  faLaptopCode,
  faRobot,
} from '@fortawesome/free-solid-svg-icons';

const AllServices = [
  {
    id: 1,
    icon: faLaptopCode,
    name: 'Full-Stack Web Applications',
    details:
      'End-to-end web apps built with React, Next.js, Node.js, and NestJS — from data modeling and API design to production deployment.',
  },
  {
    id: 2,
    icon: faRobot,
    name: 'AI-Powered Automation',
    details:
      'Custom automation tools and AI integrations that streamline workflows and connect your existing tools into one system.',
  },
  {
    id: 3,
    icon: faCloud,
    name: 'Performance & Cloud Architecture',
    details:
      'Diagnose performance bottlenecks, or architect scalable systems on AWS with Docker and CI/CD set up right from day one.',
  },
];

export default AllServices;
